module.exports = __webpack_public_path__ + "img/biuro-partner.922bb98c.jpg";